<template>
  <div class="mdc-layout-container mdc-container">
    <!-- Outlet for children routes -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Features'
}
</script>

<style></style>
